<template>
  <div ref="info-card" class="info-card">
    <div class="info-card__content" :class="{ 'info-card__content--custom': isCustom, hideMsg: !showMsg }">
      <template v-if="isCustom">
        <img class="info-card__image" src="@/assets/img/illustrations/meditation.svg" :alt="customTitle" />
        <div class="info-card__text-container">
          <strong class="info-card__title" v-html="customTitle"></strong>
          <p class="info-card__text" v-html="customMessage"></p>
        </div>
      </template>

      <template v-else>
        <img class="info-card__image" :src="imageSrc" :alt="imageAlt" :style="'height:' + height" />
        <p class="info-card__text" v-if="showMsg" v-html="messageText" />
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    error: { type: Boolean, default: false },
    height: { type: String, default: null },
    showMsg: { type: Boolean, default: true },
    customTitle: { type: String, default: '' },
    customMessage: { type: String, default: '' },
    noSearchResults: { type: Boolean, default: false },
  },
  computed: {
    isCustom() {
      return this.customTitle && this.customMessage;
    },
    imageSrc() {
      return this.error
        ? require('@/assets/img/illustrations/settings.svg')
        : require('@/assets/img/illustrations/empty.svg');
    },
    imageAlt() {
      return this.error ? this.$t('error-message') : this.$t('is-empty-message');
    },
    messageText() {
      return this.error
        ? this.$t('error-message')
        : this.noSearchResults
        ? this.$t('no-search-results')
        : this.$t('is-empty-message');
    },
  },
};
</script>

<style lang="scss" scoped>
.info-card {
  &__content {
    text-align: center;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &--hidden {
      display: none;
    }

    &--custom {
      flex-direction: column;
      align-items: center;
      text-align: left;
      width: 100%;
      justify-content: center;
    }
  }

  &__image {
    width: 180px;
    height: 180px;
  }

  &__text-container {
    display: flex;
    flex-direction: column;
    width: 62%;
  }

  &__title {
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    color: $gray-700;
    line-height: 24px !important;
  }

  &__text {
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    color: $gray-700;
  }
}
</style>
